<template>
  <div class="btnitem" :class="{isfocus:item.isFocus}" @click="clickAttention(!item.isFocus)">
    <img v-if="item.isFocus" src="@/assets/attentiondonenew@2x.png" width="21px" height="20px"/>
    <img v-else src="@/assets/attentionhuise@2x.png" width="20px" height="20px"/>
    <span>{{item.isFocus?'已关注':'关注'}}</span>
  </div>
</template>

<script>
import {apiResignAll} from "@/api/apiResignAll"
import {checkDataStatus} from "@/utils/checkDataStatus"


export default {
  name: "focus",
  props:{
    item:{
      type:Object,
      default(){
        return {}
      }
    },
    type: {
      type: [Number,String] // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工
    }
  },
  data(){
    return {
      isRepeatSubmit:false
    }
  },
  methods:{
    //关注
    async clickAttention(state) {
      if(this.permissionTips()) return

      const dataState = await checkDataStatus(this.type,this.item.no)
      if(!dataState){
        this.$message.error('系统异常，请稍后再试')
        return
      }
      if(dataState!=1){
        this.$emit('changeStatus',dataState)
        return
      }


        let no = this.$route.query.no
        if (this.isRepeatSubmit) return
        this.isRepeatSubmit = true
        apiResignAll
          .addAttention(no, this.type, state)
          .then(res => {
            if (res.data.code === 200 && res.data.data !== "不能关注自己发布的信息") {
              this.$message.success(res.data.data)
              this.$emit('end',no)
            } else {
              this.$message.error(res.data.data)
            }
          })
          .finally(() => {
            this.isRepeatSubmit = false
          })

    },
  }
}
</script>

<style lang="scss" scoped>
.btnitem{
  color: #969696 !important;
  border: 1px solid #E4E7ED !important;
  background: #fff;
}
.isfocus{
  color: #FF6600 !important;
  border: 1px solid #FF6600 !important;
  background: #fff;
}
</style>
